import { render, staticRenderFns } from "./jlCreateProject.vue?vue&type=template&id=264be309&scoped=true"
import script from "./jlCreateProject.vue?vue&type=script&lang=js"
export * from "./jlCreateProject.vue?vue&type=script&lang=js"
import style0 from "./jlCreateProject.vue?vue&type=style&index=0&id=264be309&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264be309",
  null
  
)

export default component.exports